import React from 'react'

function Question() {
    return (
        <div className="container">
          <h2>TASK</h2>
          <figure>
  <blockquote class="blockquote">
    <p class="mb-0">
    You have just been employed as a React frontend developer by SkyHigh who is into retail in the UK. The marketing team is about to embark on a promotion and they wanted to be guided by insights from historical sales data.
  Develop a React application that makes a POST call to one of the SkyHigh API endpoints below which returns sales data over the last four years in json format. 
  The application should display the data in tables.
</p>
  
  </blockquote>
  <figcaption class="blockquote-footer">
   <cite title="">Datamellon</cite>
  </figcaption>
</figure>
    

        </div>
    )
}

export default Question
